<template>
    <div class="filter__query">
        <input aria-label="search trails input" type="text" class="filter__query--input" placeholder="🔎 Search a trail ..." v-model="input" autocomplete="off">
        <div class="filter__query--suggest">
            <router-link :to="{name: 'Trail', params:{slug:trail.slug}}" v-for="trail in matchedTrails" :key="trail.slug" class="filter__query--suggestion filter__query--suggestion-link">
                   {{trail.name}}
                  <img v-for="country in trail.countries" :key="country" :src="`${apiLink}/images/flag/thumbnail/${country.iso}.webp`" class="filter__query--suggestion-flag"/>
            </router-link>
        </div>
    </div>
</template>

<script>
import { computed, ref, watch } from 'vue'


export default {
    props: ['trails'],
    setup(props){
        const matchedTrails = ref([])
        const input = ref();
        const apiLink = process.env.VUE_APP_API_BASEURL;
        const inputValue = '';

        const matchTrails = (input) => {
            matchedTrails.value = [];
            if(input){
                const input_filter = input.trim().toLowerCase().replace(/\s/g, "");
                props.trails.forEach((el) => {
                    const name_filter = el.name.trim().toLowerCase().replace(/\s/g, "");
                    if (name_filter.includes(input_filter)) {
                        matchedTrails.value.push(el);
                    }
                })
            }
        };

        const inputWatch = watch(input,( newVal, olVal ) => {
            matchTrails(newVal)
        });


        return{
            apiLink,
            input,
            inputWatch,
            matchTrails,
            matchedTrails
        }
    }

}
</script>

<style lang="scss">

@import '../../style/main';

.filter{
    &__query{
        position: relative;
        flex: 1;

        @include respond(phone){
            width: 100%;
            margin-bottom: 2rem;
        }
        &--input{
            width: 100%;
            padding: .7rem 1.6rem;
            height: 5rem;
            border: 1px solid currentColor;
            box-shadow: $shadow-light;
            font-size: 1.4rem;
            letter-spacing: .1rem;
            outline: none;
            border-radius: 3px;
            color:$color-grey-65;
            font-weight: 400;

            transition: all .2s;

            &:hover, 
            &:focus{
                border: 1px solid $color-blue-light;
            }

        }

        &--suggest{
            display: flex;
            flex-direction: column;
            &:empty{
                display: none;
            }

            z-index: 2000;
            position: absolute;
            top: 100%;
            left: 0;

            width: 100%;
            background-color: $color-white;
            border: 1px solid currentColor;
            margin-top: .1rem;
            border-radius: 3px;
        }
        &--suggestion{
            display: flex;
            align-items: center;
            padding: .8rem 1.3rem;
            font-size: 1.6rem;
            text-transform: uppercase;
            letter-spacing: .1rem;
            
      

            color:inherit;
            text-decoration: none;

            &:not(:last-child) {
              border-bottom: 1px solid $color-grey-50;
            }

            transition: all .2s;
      
            
            &-flag {
                height: 1.6rem;
                width: auto;
                margin-left: 1.5rem;
              }
              &-link{
                &:hover {
                    background-color: $color-grey-50;
                    color: $color-white;
                  }
              }
        
        }
    }
}

</style>